import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "Do I need to install any software?",
      a: "No. AgentOnDemand runs directly on your existing booking page — nothing to download, nothing to maintain."
    },
    {
      q: "What happens outside my covered hours?",
      a: "Visitors are handed off according to your after-hours setup, so no lead goes untouched even when your agent isn’t live."
    },
    {
      q: "Who are the agents?",
      a: "Trained specifically on your business, your offers, and how you like appointments handled — so every conversation reflects your brand."
    },
    {
      q: "Does this replace my current chatbot or form?",
      a: "Yes — AgentOnDemand is built to replace both, because the outcome you actually want (a booked appointment) comes from a real conversation, not a script."
    },
    {
      q: "How fast can this go live on my site?",
      a: "Days, not weeks."
    },
    {
      q: "Is there a contract?",
      a: "No contracts required to start."
    }
  ];

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-24 bg-navy-light border-y border-white/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-anton uppercase tracking-wide text-white">
            Common <span className="text-gold">Questions</span>
          </h2>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="bg-navy border border-white/10 rounded-xl overflow-hidden"
            >
              <button 
                onClick={() => toggle(idx)}
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
              >
                <span className="text-lg font-medium text-white pr-8">{faq.q}</span>
                <SafeIcon 
                  icon={FiIcons.FiChevronDown} 
                  className={`text-gold text-xl flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              
              <AnimatePresence>
                {openIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-5 text-gray-400 border-t border-white/5 pt-4 leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;